// extracted by mini-css-extract-plugin
export var isPrintedCell = "_y5-1";
export var printerIcon = "_y5-0";